import type { SxProps, Theme } from '@mui/material/styles';

import { signupPageStyles, signupTypography } from '../../../pages/signup/SignupPage/SignupPage.styles';
import { signupResultLayoutStyles } from '../SignupResultLayout/SignupResultLayout.styles';

const applicationButtonBlue = '#0090fa';

export const signupAccountExistsStyles = {
  accountHeading: signupPageStyles.accountHeading,
  input: signupPageStyles.input,
  actionError: signupPageStyles.actionError,
  emailButton: signupPageStyles.emailButton,
  resultMessage: signupResultLayoutStyles.resultMessage,
  resultActions: signupResultLayoutStyles.resultActions,
  inlineResult: signupResultLayoutStyles.inlineResult,
  accountInfo: (theme: Theme): SxProps<Theme> => ({
    display: 'grid',
    gridTemplateColumns: '48px 1fr',
    gap: 1.5,
    alignItems: 'center',
    mb: 2,
    p: 2.5,
    border: `1px solid ${applicationButtonBlue}`,
    borderRadius: 1,
    bgcolor: 'rgba(0, 144, 250, 0.08)',
    fontSize: signupTypography.standard,
    '& .MuiTypography-root': {
      fontSize: signupTypography.standard,
    },
  }),
  existingAccountForm: (): SxProps<Theme> => ({
    display: 'grid',
    gap: 2.5,
    '& [role="alert"]': {
      m: 0,
    },
  }),
  infoIcon: (): SxProps<Theme> => ({
    display: 'flex',
    width: '40px',
    height: '40px',
    alignItems: 'center',
    justifyContent: 'center',
    border: '3px solid #147df5',
    borderRadius: '50%',
    color: '#147df5',
    fontSize: signupTypography.sectionHeading,
    fontWeight: 700,
    fontFamily: 'serif',
  }),
  outlinedAction: (theme: Theme): SxProps<Theme> => ({
    height: '49px',
    mt: 1.5,
    borderColor: applicationButtonBlue,
    color: '#147df5',
    fontSize: signupTypography.standard,
    fontWeight: 600,
    textTransform: 'none',
    '&:hover': {
      borderColor: '#007dcc',
      bgcolor: 'rgba(0, 144, 250, 0.04)',
    },
    '&:focus-visible': {
      outline: '3px solid rgba(0, 144, 250, 0.35)',
      outlineOffset: '3px',
    },
  }),
};
